import { CustomerInformationEffect } from './customer-information.effect';

export const successionEffects = [CustomerInformationEffect];

export * from './customer-information.effect';
